<template>
  <v-container>
    <!-- Trigger button -->
    <!-- Confirmation Dialog -->
    <v-dialog v-model="dialog" max-width="400px">
      <v-card>
        <v-card-title class="text-h6">
          {{ title }}
        </v-card-title>
        <v-card-text>
          {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="onYes">
            Yes
          </v-btn>
          <v-btn color="secondary" @click="onNo">
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "Confirmation",
    },
    message: {
      type: String,
      default: "Are you sure you want to proceed?",
    },
    callback: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      dialog: true,
    };
  },
  methods: {
    onYes() {
      this.dialog = false; // Close the dialog
      this.$emit('onYesEvent');
    },
    onNo() {
      // this.dialog = false; // Close the dialog without any action
      this.$emit('onNoEvent');
    },
  },
};
</script>
